export interface EntityFormReducerState {
  savingForm: boolean;
  saveFormError: string | null;
  submitForm: boolean;
  testConnectionTaskId: string | null;
  testConnectionRunning: boolean;
  testConnectionError: string | null;
  testConnectionSuccessful: boolean;
}

export enum EntityFormReducerActionType {
  SUBMIT_FORM = 'SUBMIT_FORM',
  INIT_TEST_CONNECTION = 'INIT_TEST_CONNECTION',
  SAVE_TEST_CONNECTION_ERROR = 'SAVE_TEST_CONNECTION_ERROR',
  SAVE_TEST_CONNECTION_SUCCESS = 'SAVE_TEST_CONNECTION_SUCCESS',
  SAVE_FORM_ERROR = 'SAVE_FORM_ERROR',
  SAVE_FORM = 'SAVING_FORM',
  SAVE_TEST_CONNECTION_TASK_ID = 'SAVE_TEST_CONNECTION_TASK_ID'
}

export interface EntityFormReducerAction {
  type: EntityFormReducerActionType;
  data?: Partial<EntityFormReducerState>;
}

export type EntityFormReducerType = (
  state: EntityFormReducerState,
  action: EntityFormReducerAction
) => EntityFormReducerState;
